import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon'
import { EditSVGComponent, InfoSVGComponent } from '@monorepo-channels/components/ui-common'
import { FormsModule } from '@angular/forms'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TooltipUiComponent } from '@monorepo-channels/components/ui-bb'
import { ClickableTooltipDirective } from '@monorepo-channels/shared/util-helpers'
import { VoucherService } from './voucher.service'

@Component({
	standalone: true,
	selector: 'feature-bb-voucher',
	imports: [
		CommonModule,
		FormsModule,
		InfoSVGComponent,
		EditSVGComponent,
		MatInputModule,
		MatIconModule,
		MatTooltipModule,
		TooltipUiComponent,
		ClickableTooltipDirective,
	],
	templateUrl: './voucher.component.html',
	styleUrls: ['./voucher.component.scss'],
	providers: [VoucherService],
})
export class VoucherComponent {
	@Input({ required: true }) stage = 1

	@Input({ required: true }) code: string | undefined

	@Input({ required: true }) points: number | undefined

	@Output() voucherEmitter = new EventEmitter<Voucher>()

	@Input() showInfo = false

	buttonDisabled = true
	showMessage = false
	errorMessage = ''

	constructor(private voucherService: VoucherService) {}

	// private voucherService = Inject(VoucherService)

	updateVoucher() {
		this.showMessage = false
		this.errorMessage = ''
		this.buttonDisabled = this.code === ''
	}

	onInput(event: Event) {
		const currentInput = event.target as HTMLInputElement
		currentInput.value = currentInput.value.toUpperCase()
	}

	validateVoucher() {
		if (this.code) {
			this.voucherService.validateVoucher(this.code).subscribe({
				next: (voucher: Voucher) => {
					if (voucher.status === VOUCHERBB_STATUS.ACTIVE) {
						this.vaucherValid(voucher)
					} else {
						this.vaucherInvalid(voucher.status)
					}
				},
				error: () => {
					this.vaucherInvalid('')
				},
			})
		}
	}

	vaucherValid(voucher: Voucher) {
		this.stage = 3
		this.points = voucher.points
		this.code = voucher.code
		this.voucherEmitter.emit(voucher)
	}

	vaucherInvalid(status: string) {
		this.buttonDisabled = true
		this.showMessage = true
		if (status === VOUCHERBB_STATUS.REDEEMED) {
			this.errorMessage = 'Voucher já utilizado'
		} else if (status === VOUCHERBB_STATUS.EXPIRED) {
			this.errorMessage = 'Voucher expirado'
		} else if (status === VOUCHERBB_STATUS.CANCELED) {
			this.errorMessage = 'Voucher cancelado'
		} else if (status === VOUCHERBB_STATUS.SCHEDULED) {
			this.errorMessage = 'Voucher agendado'
		} else {
			this.errorMessage = 'Voucher inválido'
		}
	}
}

export interface Voucher {
	code: string
	points: number
	status: VOUCHERBB_STATUS
}

export enum VOUCHERBB_STATUS {
	ACTIVE = 'active',
	REDEEMED = 'reedemed',
	EXPIRED = 'expired',
	CANCELED = 'canceled',
	SCHEDULED = 'scheduled',
}
